<template>
	
	<div id="header-menu" class="header-menu">
    
		<div class="d-flex main-menu">
		    
	  	<div class="align-items-center iarc-logo-scrolling">
	        <a href="https://iarc.who.int/" title="IARC">
	            <img class="header-menu-logo" src="https://www.iarc.who.int/wp-content/themes/iarc-theme-new/images/layout/logo-white.svg" alt="logo-white">
	        </a>

	        <a href="https://gco.iarc.who.int" class="btn-website">
	    			<img :src=" mobile_logo ">
	    		</a>

	  	</div>
				
			<div class="header-menu-row d-flex">
        <div class="header-menu-links d-flex align-items-center">
            
           <div :class="['menu-item']" v-for="menu in menus">
          	<router-link :to="{ name : menu.route , params : { lang : 'en' } }">{{ menu.label }}</router-link>
          </div>

        </div>

        <div class="header-menu-search align-item-center">
	    		
	        <!--<a href="/search" id="btn-search" class="btn-search">
	            <i class="icon-search"></i>
	        </a>
	        <div class="btn-donations-custom ml-2">
	            <a href="https://www.iarc.who.int/donations/" target="_blank" class="support-button">Donate</a>
	        </div>-->
        </div>
			</div>
		</div>

	</div>

</template>

<script>

export default {
  name: 'HeaderTopPage',
  components: {

  },
  props : {
    menus : { type : Array , default : [] }
  },
  data () {
    return {
    	route : '' , 
    	// into public folder
	    mobile_logo : 'https://gco.iarc.who.int/img/GCO-logo-White-60.png'
    }
  },
  mounted () { 
  	
  	/*if ( process != undefined && process.env.BASE_URL != undefined ){
  		this.mobile_logo = '/today/img/CancerToday-logo-with-text-white.png' ; 
  	}*/

  	// improve
  	let pathnames = document.location.pathname.split('/') ; 
  	// console.log("pathnames",pathnames) ;

  	if ( pathnames.includes( 'today' ) ||  pathnames.includes( 'today_ps27' ) ) 
  		this.mobile_logo = `/${pathnames[1]}/img/CancerToday-logo-with-text-white.png` ; 

  	// console.log(" => " , pathname )

  	// block from spherical : might delegat to 
  	$(document).ready( () =>{
		
			// $(this).find('.follow-us').mCustomScrollbar({axis: 'x'});

			window.addEventListener('scroll',  () => {

				const headerBlock = $('.header .header-top')[0];
	      const headerMenu = $('.header #header-menu')[0];
				
				if (headerMenu === undefined || $(headerMenu).is(':hidden')) {
					return;
				}

				let scrollingHeader = headerBlock && headerBlock.offsetHeight < (window.scrollY-10);

				/*console.info("=>",{
					offsetHeight:headerBlock.offsetHeight,
					scrollY:window.scrollY });*/
				
				// 
				if (scrollingHeader && !$('body').hasClass('long-read') ) 
				{
		      $('body').addClass('body_scrolling');
		      $('header,.page.dataviz').addClass('scrolling');
					$('.iarc-logo-scrolling').addClass('d-flex');
					$('.header-menu-search').addClass('d-flex');
				}
				else 
				{
					$('body').removeClass('body_scrolling');
					$('header,.page.dataviz').removeClass('scrolling');
					$('.iarc-logo-scrolling').removeClass('d-flex');
					$('.header-menu-search').removeClass('d-flex');
				}
			});

		});

  }
}
</script>

<style lang="scss">

.btn-website{
	margin-right: 20px ;
	margin-left: 35px ;
	img{
		max-height: 55px;
	}
}

.burger{
	width: 40px;
}

.header.scrolling .header-menu-row{
	width: auto ; 
}

</style>